import { Container } from '@consumer-frontend/shared-ui';

import { NcVerifyIdentityForm } from './NcVerifyIdentityForm';
import { useVerifyIdentitySubmit } from './useVerifyIdentitySubmit';
import { useApplyRouting } from '../../routing';
import { NcPageWithAlertBanner } from '../NcPageWithAlertBanner';
import { NcProgressBar } from '../NcProgressBar';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/verify_identity.scss';

export const NcVerifyIdentityPage = (): React.JSX.Element => {
  const {
    handleBack,
    progress,
  } = useApplyRouting();

  const { handleSubmit, isSubmitting } = useVerifyIdentitySubmit(false);

  return (
    <NcPageWithAlertBanner>
      <Container hasBoxShadow className="nc-verify-identity-page">
        {!!progress.current && (<NcProgressBar progress={progress} />)}

        <h1 className="h3">Verify Identity</h1>

        <p>We use this information to verify your identity and keep your account secure.</p>

        <NcVerifyIdentityForm
          isLoading={isSubmitting}
          onSubmit={handleSubmit}
          onBack={handleBack}
        />
      </Container>
    </NcPageWithAlertBanner>
  );
};
